import {
    GET_MAIN_CATEGORIES,
    GET_CATEGORY_BY_ID,
    GET_ONE_PRODUCT,
    GET_ALL_PRODUCTS,
    GET_ALL_CUSTOMERS,
    GET_ONE_CUSTOMER,
    GET_CUSTOMER_REFERER_LINK,
    ADD_PRODUCT_TO_FAVORITE,
    GET_FAVORITES_PRODUCTS,
    DELETE_FAVORITE_PRODUCT,
    SET_EDIT_CUTOMER_NAME,
    GET_TIMEZONES,
    GET_SHOP_PRODUCTS_SEARCH
} from "../../resources/js/helpers/requests"

export default {
     state: {
    wishList: [],
    headerCategodies: [],
    categoryById: null,
    allProducts: [],
    perPage: '',
    openProduct: {},
    allCustomers: [],
    currentCustomer: null,
    customerRefererLink: null,
    timezones: [],
    //////////////
    products: [],
    perCategoris: [],
    max_price: 0,
    searchText: '',
    filterParametrs: {},
    checkedCategory: null,
    customCustomerInfo: {
      firstName: null,
      lastName: null,
      phoneNumber: null,
    }
  },
  mutations: {
    addToWishList(state, product) {
       state.wishList = [...state.wishList, product]
    },
    deleteOnWishList(state, product) {
      let deleted = state.wishList.filter(el => el.id !== product.id) 
        state.wishList = deleted
    },
    updateMainCategories(state, category) {
        state.headerCategodies = category
    },
    addCategoryById(state, category) {
      state.categoryById = category
    },
    setAddAllProducts(state, products) {
      state.allProducts = products
    },
    setAddAllCustomers(state, customers) {
      state.allCustomers = customers
    },
    setCurrentCustomer(state, customer) {
      state.currentCustomer = customer
    },
    setSaveRefererLink(state, link) {
      state.customerRefererLink = link
    },
    setWishList(state, list) {
      state.wishList = list
    },
    setSaveTimeZones(state, zones) {
      state.timezones = zones
    },
    //////////////////////
   addPerPage(state, page) {
    state.perPage = page
   },
   setIsOpenProductInfo(state, product) {
    state.openProduct = product
   },
   setAddPerCategory(state, category) {
    state.perCategoris = category
   },
   setAddProducts(state, products) {
    state.products = products
   },
   setAddMaxPrice(state, price) {
    state.max_price = price
   },
   setChangeSearchText(state, text) {
    state.searchText = text
   },
   setFilterParametrs(state, data) {
    state.filterParametrs = data
   },
   deleteFilterCategoryParametr(state) {
      state.filterParametrs = delete state.filterParametrs.category_ids
   },
   setFilterPriceParametrs(state, data) {
     state.filterParametrs = { 
    ...state.filterParametrs,
    price_from: data.price_from,
    price_to: data.price_to
    }
    console.log({state})
   },
   deleteFilterParametr(state) {
      state.filterParametrs = {}
   },
   setCheckedCategory(state, data) {
    state.checkedCategory = data
   },
   setChangeCustomerInfo(state, data) {
    state.customCustomerInfo = data
   }
  },
  actions: {
    async getMainCategories({commit}) {
        let result = await GET_MAIN_CATEGORIES()
        commit('updateMainCategories', result.data)
    },
    async getCategoryById({commit}, id) {
      let result = await GET_CATEGORY_BY_ID(id)
      commit('addCategoryById', result.data)
    },
    async getOneProduct({commit}, id) {
      let result = await GET_ONE_PRODUCT(id)
      commit('setIsOpenProductInfo', result.data)
    },
    async getAllProducts({commit}) {
      let result = await GET_ALL_PRODUCTS()
      commit('setAddAllProducts', result?.data)
    },
    async getAllCustomers({commit}) {
      let result = await GET_ALL_CUSTOMERS()
      commit('setAddAllCustomers', result.data)
    },
    async getCurrentCustomer({commit}, id) {
      let result = await GET_ONE_CUSTOMER(id)
      let resultWish = await GET_FAVORITES_PRODUCTS(id)
      commit('setCurrentCustomer', result.data)
      commit('setWishList', resultWish.data)
    },
    async getCustomerrefereLink({commit}, id) {
      let result = await GET_CUSTOMER_REFERER_LINK(id)
      commit('setSaveRefererLink', result.referer_link)
    },
    async setProductToWishes({commit, state}, data) {
      let same = state.wishList.find(el => el.id === data.id)
      if (same) {
        await DELETE_FAVORITE_PRODUCT(data.customer_id, data.id)
        commit('deleteOnWishList', data)
      } else {
        await ADD_PRODUCT_TO_FAVORITE(data.customer_id, data.id)
        commit('addToWishList', data)
      }  
    },
    async setEditCustomerName({commit}, {id, name, reminder_new, reminder_favorite, timezone }) {
      let result = await SET_EDIT_CUTOMER_NAME(id, name, reminder_new, reminder_favorite, timezone)
      commit('setCurrentCustomer', result.data)
    },
    async getTimezones({commit}) {
      let result = await GET_TIMEZONES()
      commit('setSaveTimeZones', result)
    },
    // async getProductsReq({commit}, id) {
    //   let result = await GET_CATEGORY(id)
    //   if (result.data?.children.length) {
    //     commit('setIsShowProducts', 'preCategory')
    //     commit('setAddPerCategory', result.data.children)
    //   }
    //   if (result.data?.products?.length) {
    //     commit('setIsShowProducts', 'products')
    //     commit('setAddProducts', result.data.products)
    //   }
    // },
   async searchedProducts({commit}, data) {
    let result = await GET_SHOP_PRODUCTS_SEARCH(data)
    commit('setAddAllProducts', result.data)
   },
  },
  getters: {
    perPageName: state => {
        return state.perPage
    },
    allHeaderCategories: state => {
      return state.headerCategodies  
    },
    allProducts: state => {
      return state.allProducts
    },
    allCustomers: state => {
      return state.allCustomers
    },
    currentCustomer: state => {
      return state.currentCustomer
    },
    customerRefererLink: state => {
      return state.customerRefererLink
    },
    openedProduct: state => {
      return state.openProduct
    },
    wishList: state => {
      return state.wishList
    },
    timezones: state => {
      return state.timezones
    },
    /////////////////
    preCategories: state => {
      return state.perCategoris
    },
    getProducts: state => {
      return state.products
    },
    getMaxPrice: state => {
      return state.max_price
    },
    getSearchText: state => {
      return state.searchText
    },
    getFilterParametrs: state => {
      return state.filterParametrs
    },
    getCheckedCategory: state => {
      return state.checkedCategory
    },
    customCustomerInfo: state => {
      return state.customCustomerInfo
    },
  }
}